<template>
  <div class="app-main-inner" style="width: fit-content">
    <div class="section">
      <el-form
        v-if="isFba"
        :disabled="readonly"
        class="section"
        style="flex-direction: row;"
      >
        <span style="display: flex;align-items: center;width: 64px">
          {{ $t('FbaJob.ValueAddedServices') }}
        </span>
        <el-checkbox-group v-model="selectedLocalAddedService" @change="addedServiceChangeHandler">
          <el-checkbox
            v-for="item in localAddedService"
            :key="item.code"
            :label="item.code"
            style="margin-left: 8px;margin-right: 8px"
            @change="val => singleAddedServiceChangeHandler(val, item)"
          >
            {{ item.chineseName }}
          </el-checkbox>
        </el-checkbox-group>
        <el-checkbox v-if="isBookingNew" v-model="form.destinationPortService" style="margin-left: 8px;margin-right: 8px" no="destinationPortService">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
        <el-button
          v-if="viewSource === 'bookingWorkspace'"
          v-permission="['button_insurance_toInsure']"
          :disabled="isEdit"
          no="toInsure"
          type="primary"
          style="margin-left: 20px;"
          @click="pm.toInsure()"
        >{{ $t('SeaExport.Insure') }}</el-button>
      </el-form>
      <el-form v-if="!isFba">
        <el-checkbox v-model="form.booking" :disabled="readonly" no="booking">{{ $t('SeaExport.Booking') }}</el-checkbox>
        <el-checkbox
          v-model="form.customs"
          :disabled="readonly"
          no="customs"
          style="margin-left: -20px;"
          @change="val=>{form.customsBroker=val?form.customsBroker:0;form.customsDeclarationType=val?form.customsDeclarationType:-1}"
        >{{ $t('SeaExport.CustomsDeclaration') }}</el-checkbox>
        <el-checkbox v-model="form.insure" :disabled="readonly" no="isInsure" style="margin-left: -20px;">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
        <el-checkbox
          v-model="form.comercialInspectation"
          :disabled="readonly"
          no="comercialInspectation"
          style="margin-left: -20px;"
        >{{ $t('SeaExport.CommodityInspection') }}</el-checkbox>
        <el-checkbox v-model="form.heating" :disabled="readonly" no="heating" style="margin-left: -20px;">{{ $t('SeaExport.Fumigation') }}</el-checkbox>
        <el-checkbox v-model="form.itmService" :disabled="readonly" no="itmService" style="margin-left: -20px;">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
        <el-checkbox
          v-model="form.headwayTail"
          :disabled="readonly"
          no="headwayTail"
          style="margin-left: -20px;"
        >{{ $t('RailwayExport.isHeadwayTail') }}</el-checkbox>
        <el-checkbox v-if="isBookingNew && isFba" v-model="form.destinationPortService" no="destinationPortService" style="margin-left: -20px;">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
        <el-button
          v-if="viewSource==='bookingWorkspace'"
          v-permission="['button_insurance_toInsure']"
          :disabled="isEdit"
          no="toInsure"
          type="primary"
          style="margin-left: 20px;"
          @click="pm.toInsure()"
        >{{ $t('SeaExport.Insure') }}</el-button>
        <span v-if="!isFba" style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_BusinessType') }}</span>
        <el-radio-group v-if="!isFba" v-model="form.lob" :disabled="readonly||Boolean(form.lclMasterUuid)" no="lob" style="margin-left: 10px;" @change="lobChangeHandler">
          <el-radio no="RE" label="RE">{{ $t('CargoMsg.Cargo_Export') }}</el-radio>
          <el-radio no="RI" label="RI" style="margin-left: -20px;">{{ $t('CargoMsg.Cargo_JobTypeImport') }}</el-radio>
        </el-radio-group>
        <span v-if="!!templateName" class="blue" style="float: right;margin-right: 30px;line-height: 28px;padding: 0 5px;white-space: nowrap;">{{ $t('CargoMsg.Cargo_SopTemplate') }}: {{ templateName }}</span>
      </el-form>
    </div>
    <tab-booking-FCLUICustom-layout :element-blocks="elementBlocks" :disabled="readonly">
      <el-form-item v-if="elementDict.jobNo.slaveVisible" slot="jobNo">
        <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
        <el-input :value="form.jobNo" :disabled="true" no="jobNo" />
      </el-form-item>
      <template v-if="isZY">
        <el-form-item slot="saleProductCode">
          <line-label slot="label" class="blue" :label="$t('SeaExport.AllowSaleProduct')" />
          <cargo-advance-select
            :select-type="selectTypeNames.basic_data_AllowSaleProduct"
            filterable
            no="allowSaleProduct"
            clearable
            :data-filter-function="p => {
              if (!p.statusEnabled) {
                return false
              }
              return isFba ? p.fbaSea : p.seaExportEnabled
            }"
            :default-value="form.saleProductCode || ''"
            @parentCallBack="p => {form.saleProductCode = p.value}"
          />
        </el-form-item>
        <el-form-item slot="fullOrInside">
          <line-label slot="label" class="blue" :label="$t('SeaExport.FullOrInside')" />
          <cargo-advance-select
            :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
            no="fullOrInside"
            clearable
            :default-value="form.fullOrInside || ''"
            @parentCallBack="p => {form.fullOrInside = p.value}"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.customerId.slaveVisible" slot="customerId">
        <line-label slot="label" :class="elementDict.customerId.isRequire ? 'blue' : ''" :label="elementDict.customerId.label" />
        <div style="display: flex;align-items: center">
          <el-tooltip
            v-show="showWarningImageB"
            :content="warningImageBTip"
            placement="right-end"
          >
            <i
              class="el-icon-warning red"
              style="cursor: pointer"
            />
          </el-tooltip>
          <cargo-sales-company-select
            v-if="!isFba"
            no="customerId"
            :method-params="{customer:true,active:true,companyLob:'railwayExport'}"
            :check-credit="true"
            :default-value="form.customerId||''"
            :disabled="!customerEnabled"
            :job="form"
            @parentCallBack="p=>{customerIdChange2ContractHandler(p);clearPoNo()}"
          />
          <cargo-company-select
            v-if="isFba"
            no="customerId"
            :method-params="{customer:true,companyLob:'railwayExport',active:true, fba:true}"
            :check-credit="true"
            :job="form"
            :default-value="form.customerId||''"
            :disabled="!customerEnabled"
            style="flex: 1;"
            :data-filter-function="fbaCustomerIdFilter"
            @change="p=>{customerIdChange2ContractHandler(p);clearPoNo()}"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.customerLevel.slaveVisible" slot="customerLevel">
        <line-label slot="label" :class="elementDict.customerLevel.isRequire ? 'blue' : ''" :label="elementDict.customerLevel.label" />
        <el-tooltip :content="customerTip" placement="bottom">
          <span
            v-show="customerLevel.level!==''"
            style="color:#FD9A14"
          >LV{{ customerLevel.level }}</span>
          <span style="color:#D3A73B">&nbsp;{{ customerLevel.customerName }}</span>
          <span v-show="contractStatusLabel" class="red">&nbsp;({{ contractStatusLabel }})</span>
          <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
          <span v-show="stampPictureView.businessDocuments.length > 0" @click="stampPictureView.visible = true">
            <img :title="$t('Message.BookingSeal')" :src="stampIcon" height="14" style="text-align: right;">
          </span>
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="elementDict.customerContact.slaveVisible" slot="customerContact">
        <line-label slot="label" :class="elementDict.customerContact.isRequire ? 'blue' : ''" :label="elementDict.customerContact.label" />
        <div style="display: flex">
          <el-select
            v-model="form.customerContact"
            no="customerContact"
            filterable
            :allow-create="true"
            style="flex:1"
          >
            <el-option
              v-for="(item,index) in contactList"
              :key="index"
              :label="item.contactPerson"
              :value="item.contactPerson"
            />
          </el-select>&nbsp;
          <el-link
            v-show="!isShowContactPersonDetail"
            no="Detail"
            :class="form.customerContact?'':'not-click'"
            @click="showContactDialog"
          >{{ $t('SeaExport.Detail') }}</el-link>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.containerLoadType.slaveVisible" slot="containerLoadType">
        <line-label slot="label" :class="elementDict.containerLoadType.isRequire ? 'blue' : ''" :label="elementDict.containerLoadType.label" />
        <el-select
          v-model="form.containerLoadType"
          :disabled="!lclslaveEnabled"
          no="containerLoadType"
          @change="val=>{pm.containerLoadTypeChange(val)}"
        >
          <el-option
            v-for="(item,index) in containerLoadTypes"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.cargoType.slaveVisible" slot="cargoType">
        <line-label slot="label" :class="elementDict.cargoType.isRequire ? 'blue' : ''" :label="elementDict.cargoType.label" />
        <el-select v-model="form.cargoType" filterable @change="onCargoTypeChagne">
          <el-option
            v-for="(item,index) in cargoType4JobSelect"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.transportType.slaveVisible" slot="transportType">
        <line-label slot="label" :class="elementDict.transportType.isRequire ? 'blue' : ''" :label="elementDict.transportType.label" />
        <cargo-advance-select
          :disabled="!lclslaveEnabled"
          no="transportType"
          :select-type="selectTypeNames.basic_data_TransportationType"
          :method-params="{companyLob:'railwayExport',transportType:true,active:true}"
          filterable
          :default-value="form.transportType"
          :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
          :tag-value="'code'"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{form.transportType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.fullHalf.slaveVisible" slot="fullHalf">
        <line-label slot="label" :class="elementDict.fullHalf.isRequire ? 'blue' : ''" :label="elementDict.fullHalf.label" />
        <cargo-advance-select
          :disabled="!lclslaveEnabled"
          no="fullHalf"
          :select-type="selectTypeNames.local_cache_FullHalf"
          filterable
          :default-value="form.fullHalf"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{form.fullHalf=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transportLine.slaveVisible" slot="transportLine">
        <line-label slot="label" :class="elementDict.transportLine.isRequire ? 'blue' : ''" :label="elementDict.transportLine.label" />
        <cargo-advance-select
          :disabled="!lclslaveEnabled"
          no="transportLine"
          :select-type="selectTypeNames.basic_data_RailwayLine"
          filterable
          :default-value="form.transportLine"
          :placeholder="$t('SeaExport.RequiredItem')"
          tag-name="name"
          @parentCallBack="p=>{form.transportLine=p.value;pm.refreshPlanner(p.value)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.etd.slaveVisible" slot="etd">
        <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
        <div style="display: flex">
          <el-date-picker
            no="etd"
            class="departure-date-picker"
            :value="form.etd"
            :disabled="form.uuid&&form.lclMasterUuid?true:!etdEnabled"
            type="date"
            value-format="yyyy-MM-dd"
            style="flex: 1; width:140px; margin-right: 5px"
            @input="etdChange"
          />
          <span>{{ form.sailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.eta.slaveVisible" slot="eta">
        <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="form.eta"
            :disabled="!lclslaveEnabled"
            no="eta"
            type="date"
            value-format="yyyy-MM-dd"
            style="flex: 1; width:140px; margin-right: 5px"
            @input="etaChange"
          />
          <span>{{ form.etaSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.atd.slaveVisible" slot="atd">
        <line-label slot="label" :class="elementDict.atd.isRequire ? 'blue' : ''" :label="elementDict.atd.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="form.atd"
            :disabled="!lclslaveEnabled"
            no="atd"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="flex: 1; width:140px; margin-right: 5px"
            @input="atdChange"
          />
          <span>{{ form.atdSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.ata.slaveVisible" slot="ata">
        <line-label slot="label" :class="elementDict.ata.isRequire ? 'blue' : ''" :label="elementDict.ata.label" />
        <div style="display: flex">
          <el-date-picker
            v-model="form.ata"
            :disabled="!lclslaveEnabled"
            no="ata"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            style="flex: 1; width:140px; margin-right: 5px"
            @input="ataChange"
          />
          <span>{{ form.ataSailingDay|filterWeek }}</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.customsDate.slaveVisible" slot="customsDate">
        <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
        <el-date-picker
          v-model="form.customsDate"
          no="customsDate"
          type="date"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.departureStation.slaveVisible" slot="departureStation">
        <line-label slot="label" :class="elementDict.departureStation.isRequire ? 'blue' : ''" :label="elementDict.departureStation.label" />
        <div style="display: flex">
          <cargo-advance-select
            :disabled="!lclslaveEnabled"
            no="departureStation"
            :select-type="selectTypeNames.basic_data_RailwayStation"
            filterable
            :default-value="form.departureStation"
            :placeholder="$t('SeaExport.RequiredItem')"
            @parentCallBack="departureStationChange"
          />
          <el-checkbox
            v-model="form.transfer"
            :disabled="!lclslaveEnabled"
            no="transfer"
            style="width:80px; padding-left: 5px;"
          >{{ $t('SeaExport.Transit') }}</el-checkbox>
        </div>
      </el-form-item>
      <el-form-item
        v-show="form.transfer && elementDict.transferStation.slaveVisible"
        slot="transferStation"
      >
        <line-label slot="label" :class="elementDict.transferStation.isRequire ? 'blue' : ''" :label="elementDict.transferStation.label" />
        <cargo-advance-select
          :disabled="!lclslaveEnabled"
          no="transferStation"
          :select-type="selectTypeNames.basic_data_RailwayStation"
          filterable
          :default-value="form.transferStation"
          @parentCallBack="p=>{form.transferStation=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.transitStation.slaveVisible" slot="transitStation">
        <line-label slot="label" :class="elementDict.transitStation.isRequire ? 'blue' : ''" :label="elementDict.transitStation.label" />
        <cargo-advance-select
          :disabled="!lclslaveEnabled"
          no="transitStation"
          :select-type="selectTypeNames.basic_data_RailwayStation"
          filterable
          :default-value="form.transitStation"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{form.transitStation=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationStation.slaveVisible" slot="destinationStation">
        <line-label slot="label" :class="elementDict.destinationStation.isRequire ? 'blue' : ''" :label="elementDict.destinationStation.label" />
        <cargo-advance-select
          no="destinationStation"
          :select-type="selectTypeNames.basic_data_RailwayStation"
          filterable
          :default-value="form.destinationStation"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="destinationStationChange"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationCountry.slaveVisible" slot="destinationCountry">
        <line-label slot="label" :class="elementDict.destinationCountry.isRequire ? 'blue' : ''" :label="elementDict.destinationCountry.label" />
        <cargo-advance-select
          no="destinationCountry"
          :select-type="selectTypeNames.basic_data_Country"
          filterable
          :default-value="form.destinationCountry"
          @parentCallBack="p=>{form.destinationCountry=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSource.slaveVisible" slot="cargoSource">
        <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
        <el-select
          v-model="form.cargoSource"
          :disabled="!cargoSourceEnabled"
          no="cargoSource"
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
          @change="form.designationAgent=0;pm.cargoSourceChange({fieldName:'cargoSource'})"
        >
          <el-option
            v-for="(item,index) in CARGO_SOURCES"
            :key="index"
            :label="item.chineseName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.customJobType.slaveVisible" slot="customJobType">
        <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
        <cargo-advance-select
          v-if="form.lob==='RE'"
          key="1"
          ref="customJobType"
          no="customJobType"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          filterable
          :tag-name="isZh?'name':'englishName'"
          :static-options="customJobTypeList"
          :method-params="{type:form.lob}"
          :default-value="form.customJobType"
          @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange();contractRuleFieldChange(form.customerId, form.designationAgent)}"
        />
        <cargo-advance-select
          v-else-if="form.lob==='RI'"
          key="2"
          ref="customJobType"
          no="customJobType"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          filterable
          :tag-name="isZh?'name':'englishName'"
          :static-options="customJobTypeList"
          :method-params="{type:form.lob}"
          :default-value="form.customJobType"
          @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange();contractRuleFieldChange(form.customerId, form.designationAgent)}"
        />
      </el-form-item>
      <el-form-item v-if="form.customJobType && secondaryCustomJobTypeList.length > 0 && elementDict.secondaryCustomJobType.slaveVisible" slot="secondaryCustomJobType">
        <line-label slot="label" :class="elementDict.secondaryCustomJobType.isRequire ? 'blue' : ''" :label="elementDict.secondaryCustomJobType.label" />
        <cargo-advance-select
          ref="secondaryCustomJobType"
          no="secondaryCustomJobType"
          :select-type="selectTypeNames.basic_data_CutomJobType"
          filterable
          :cache="false"
          :default-value="form.secondaryCustomJobType"
          :tag-name="isZh?'name':'englishName'"
          :static-options="secondaryCustomJobTypeList"
          @parentCallBack="p=>{form.secondaryCustomJobType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingAgent.slaveVisible" slot="bookingAgent">
        <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
        <cargo-advance-select
          :disabled="!lclslaveEnabled"
          no="bookingAgent"
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{companyLob:'railwayExport',bookingAgent:true,active:true}"
          filterable
          :default-value="form.bookingAgent||''"
          @parentCallBack="p=>{form.bookingAgent=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.portAgent.slaveVisible" slot="portAgent">
        <line-label slot="label" :class="elementDict.portAgent.isRequire ? 'blue' : ''" :label="elementDict.portAgent.label" />
        <cargo-advance-select
          :disabled="!lclslaveEnabled"
          no="portAgent"
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{companyLob:'railwayExport',portAgent:true,active:true}"
          filterable
          :default-value="form.portAgent||''"
          @parentCallBack="p=>{form.portAgent=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.forwardingAgent.slaveVisible" slot="forwardingAgent">
        <line-label slot="label" :class="elementDict.forwardingAgent.isRequire ? 'blue' : ''" :label="elementDict.forwardingAgent.label" />
        <cargo-advance-select
          :disabled="!lclslaveEnabled"
          no="forwardingAgent"
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{companyLob:'railwayExport',forwardingAgent:true,active:true}"
          filterable
          :default-value="form.forwardingAgent||''"
          @parentCallBack="p=>{form.forwardingAgent=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationAgent.slaveVisible" slot="destinationAgent">
        <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
        <el-tooltip
          :content="destinationAgentTip"
          :disabled="!showDestinationAgentWarning"
          placement="right-end"
        >
          <cargo-company-select
            ref="destinationAgent"
            no="destinationAgent"
            :disabled="!lclslaveEnabled"
            :method-params="{overseaAgent:true,active:true,companyLob:'railwayExport'}"
            :check-credit="true"
            :job="form"
            :default-value="form.destinationAgent||''"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"

            @change="p=>{pm.txtDestinationAgentChangeHandler(p)}"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item
        v-show="form.cargoSource==='NC' && elementDict.designationAgent.slaveVisible"
        slot="designationAgent"
      >
        <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
        <div style="display: flex;align-items: center">
          <el-tooltip
            v-show="showWarningImageA"
            :content="warningImageATip"
            placement="right-end"
          >
            <i
              class="el-icon-warning red"
              style="cursor: pointer"
            />
          </el-tooltip>
          <cargo-advance-select
            no="designationAgent"
            :select-type="selectTypeNames.basic_data_Company"
            :disabled="!designationAgentEnabled"
            :method-params="{designationAgent:true,active:true}"
            :check-credit="true"
            :default-value="form.designationAgent||''"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
          />
          <cargo-advance-select
            v-if="overseaAgentDataProviderChange"
            no="designationAgent2"
            :select-type="selectTypeNames.basic_data_Company"
            :cache="false"
            :disabled="!designationAgentEnabled"
            :check-credit="true"
            :default-value="form.designationAgent||''"
            filterable
            :headers="[$t('Partners.englishName')]"
            :fields="['englishName']"
            tag-name="englishName"
            :static-options="pm.designationAgentArray"
            @parentCallBack="p=>{pm.designationAgentChangeHandler(p)}"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.transportSource.slaveVisible" slot="transportSource">
        <line-label slot="label" :class="elementDict.transportSource.isRequire ? 'blue' : ''" :label="elementDict.transportSource.label" />
        <cargo-advance-select
          filterable
          :select-type="selectTypeNames.basic_data_TransportSource"
          no="transportSource"
          :default-value="form.transportSource"
          :cache="false"
          tag-value="code"
          placeholder=" "
          @parentCallBack="item=>form.transportSource=item.value"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.statisticArea.slaveVisible" slot="statisticArea">
        <line-label slot="label" :class="elementDict.statisticArea.isRequire ? 'blue' : ''" :label="elementDict.statisticArea.label" />
        <cargo-advance-select
          filterable
          :select-type="selectTypeNames.basic_data_StatisticArea"
          no="statisticArea"
          :default-value="form.statisticArea"
          :cache="false"
          tag-value="code"
          placeholder=" "
          @parentCallBack="item=>form.statisticArea=item.value"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.localService.slaveVisible" slot="localService">
        <line-label slot="label" :class="elementDict.localService.isRequire ? 'blue' : ''" :label="elementDict.localService.label" />
        <el-checkbox
          v-model="form.warehousing"
          no="warehousing"
          @change="pm.loadingTermChange('warehousing')"
        >{{ $t('SeaExport.WarehouseLoadingStorage') }}</el-checkbox>
        <el-checkbox
          v-model="form.landTransportation"
          no="landTransportation"
          @change="pm.loadingTermChange('landTransportation')"
        >{{ $t('SeaExport.DoorLoadingDelivery') }}</el-checkbox>
        <el-checkbox
          v-model="form.selfDeliver"
          no="selfDeliver"
        >{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}</el-checkbox>
      </el-form-item>
      <el-form-item v-if="elementDict.warehouseNo.slaveVisible" slot="warehouseNo">
        <line-label slot="label" :class="elementDict.warehouseNo.isRequire ? 'blue' : ''" :label="elementDict.warehouseNo.label" />
        <el-input v-model="form.warehouseNo" no="warehouseNo" style="margin-bottom: 10px;" />
        <!-- 无效的按钮（和cargo保持一致，暂不移除） -->
        <el-button
          :disabled="true"
          no="ObtainTheWarehouseNo"
          type="primary"
          style="padding-left:13px;padding-right:13px;"
        >{{ $t('SeaExport.ObtainTheWarehouseNo') }}</el-button>
      </el-form-item>
      <el-form-item v-if="elementDict.paymentMethod.slaveVisible" slot="paymentMethod">
        <line-label slot="label" :class="elementDict.paymentMethod.isRequire ? 'blue' : ''" :label="elementDict.paymentMethod.label" />
        <cargo-advance-select
          :disabled="!lclslaveEnabled"
          no="paymentMethod"
          :select-type="selectTypeNames.basic_data_PaymentMethod"
          :method-params="{companyLob:'railwayExport',paymentMethod:true,active:true}"
          filterable
          :default-value="form.paymentMethod"
          :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
          :tag-value="'code'"
          :placeholder="$t('SeaExport.RequiredItem')"
          @parentCallBack="p=>{form.paymentMethod=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.mbl.slaveVisible" slot="mbl">
        <line-label slot="label" :class="elementDict.mbl.isRequire ? 'blue' : ''" :label="elementDict.mbl.label" />
        <el-input v-model="form.mbl" no="mbl" />
      </el-form-item>
      <el-form-item v-if="elementDict.vessel.slaveVisible" slot="vessel">
        <line-label slot="label" :class="elementDict.vessel.isRequire ? 'blue' : ''" :label="elementDict.vessel.label" />
        <el-input v-model="form.vessel" no="vessel" />
      </el-form-item>
      <el-form-item v-if="elementDict.voyageFlight.slaveVisible" slot="voyageFlight">
        <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
        <el-input v-model="form.voyageFlight" no="voyageFlight" />
      </el-form-item>
      <el-form-item v-if="elementDict.masterJobNo.slaveVisible" slot="masterJobNo">
        <line-label slot="label" :class="elementDict.masterJobNo.isRequire ? 'blue' : ''" :label="elementDict.masterJobNo.label" />
        <el-input :value="form.lclMaster?form.lclMaster.jobNo:''" :disabled="true" no="MblNo3" />
      </el-form-item>
      <el-form-item v-if="elementDict.customerRefNo.slaveVisible" slot="customerRefNo">
        <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
        <cargo-input v-model="form.customerRefNo" no="customerRefNo" :trim="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.poNo.slaveVisible" slot="poNo" :class="poNoRed?'poNoClass':''">
        <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
        <el-input
          v-if="!openProjectConfig"
          v-model="form.poNo"
          no="poNo"
        />
        <cargo-project-select
          v-if="openProjectConfig"
          no="poNo"
          :default-value="form.poNo"
          :customer-id="form.customerId"
          :is-linked="isProjectLinkedCustomer"
          @change="p=>{form.poNo=p.value;form.projectName=p.projectName;changeProject()}"
        />
      </el-form-item>
      <el-form-item
        v-if="openProjectConfig && elementDict.projectName.slaveVisible"
        slot="projectName"
      >
        <line-label slot="label" :class="elementDict.projectName.isRequire ? 'blue' : ''" :label="elementDict.projectName.label" />
        <el-input v-model="form.projectName" :disabled="true" />
      </el-form-item>
      <el-form-item
        v-if="openProjectConfig && elementDict.projectBatch.slaveVisible"
        slot="projectBatch"
      >
        <line-label slot="label" :class="elementDict.projectBatch.isRequire ? 'blue' : ''" :label="elementDict.projectBatch.label" />
        <el-input v-model="form.projectBatch" no="projectBatch" />
      </el-form-item>
      <el-form-item v-if="elementDict.customsBroker.slaveVisible" slot="customsBroker">
        <line-label slot="label" :class="elementDict.customsBroker.isRequire ? 'blue' : ''" :label="elementDict.customsBroker.label" />
        <cargo-advance-select
          :disabled="!customsBrokerEnabled"
          no="customsBroker"
          :select-type="selectTypeNames.basic_data_Company"
          :data-filter-function="customsBrokerFilter"
          filterable
          :method-params="{customsBroker:true}"
          :default-value="form.customsBroker||''"
          :placeholder="form.customs?$t('CargoMsg.Cargo_keyWordsTip'):$t('SeaExport.PleaseTickCustomsDeclarationOption')"
          @parentCallBack="p=>{pm.customsBrokerChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customClaim.slaveVisible" slot="customClaim">
        <line-label slot="label" :class="elementDict.customClaim.isRequire ? 'blue' : ''" :label="elementDict.customClaim.label" />
        <cargo-advance-select
          no="customsMethod"
          :disabled="!customsBrokerEnabled"
          :select-type="selectTypeNames.basic_data_CustomsMode"
          :method-params="{serviceType:2}"
          tag-value="serialNum"
          filterable
          :default-value="form.customClaim"
          @parentCallBack="p=>{form.customClaim=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customsDeclarationType.slaveVisible" slot="customsDeclarationType">
        <line-label slot="label" :class="elementDict.customsDeclarationType.isRequire ? 'blue' : ''" :label="elementDict.customsDeclarationType.label" />
        <cargo-advance-select
          no="customsDeclarationType"
          :disabled="!customsBrokerEnabled"
          :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
          filterable
          :default-value="form.customsDeclarationType===-1?'':form.customsDeclarationType"
          :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
          @parentCallBack="p=>{form.customsDeclarationType=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.tradeTerm.slaveVisible" slot="tradeTerm">
        <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
        <cargo-advance-select
          no="tradeTerm"
          filterable
          :select-type="selectTypeNames.basic_data_TradeTerm"
          callback-method-type="value"
          :default-value="form.tradeTerm"
          :callback-params="{key:'tradeTerm'}"
          @parentCallBack="p=>{form.tradeTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.incoTerm.slaveVisible" slot="incoTerm">
        <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
        <cargo-advance-select
          no="incoTerm"
          filterable
          :clearable="false"
          :select-type="selectTypeNames.basic_data_IncoTerm"
          callback-method-type="value"
          :default-value="form.incoTerm"
          :callback-params="{key:'incoTerm'}"
          placeholder=" "
          @parentCallBack="p=>{form.incoTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.carryingCmp.slaveVisible" slot="carryingCmp">
        <line-label slot="label" :class="elementDict.carryingCmp.isRequire ? 'blue' : ''" :label="elementDict.carryingCmp.label" />
        <cargo-company-select
          :disabled="!form.landTransportation"
          no="carryingCmp"
          :method-params="{truckCmp:true,active:true}"
          :default-value="form.carryingCmp||''"
          :placeholder="form.landTransportation?$t('CargoMsg.Cargo_keyWordsTip'):$t('SeaExport.PleaseTickDoorLoadingDeliveryOption')"
          @change="p=>{pm.carryingCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.freightTerm.slaveVisible" slot="freightTerm">
        <line-label slot="label" :class="elementDict.freightTerm.isRequire ? 'blue' : ''" :label="elementDict.freightTerm.label" />
        <cargo-advance-select
          no="freightTerm"
          :select-type="selectTypeNames.basic_data_ShippingTerm"
          filterable
          :clearable="false"
          :default-value="form.freightTerm"
          @parentCallBack="p=>{form.freightTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.warehouseCmp.slaveVisible" slot="warehouseCmp">
        <line-label slot="label" :class="elementDict.warehouseCmp.isRequire ? 'blue' : ''" :label="elementDict.warehouseCmp.label" />
        <cargo-company-select
          :disabled="!warehouseEabled"
          no="warehouseCmp"
          :method-params="{warehouse:true,active:true}"
          :default-value="isFba ? Number(fbaJob.domesticWarehouse)||'' : form.warehouseCmp||''"
          :placeholder="form.warehousing?$t('CargoMsg.Cargo_keyWordsTip'):$t('SeaExport.PleaseSelectWarehouse')"
          @change="p=>{pm.warehouseCmpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="openWarehouse && !isFba && elementDict.warehouseName.slaveVisible" slot="warehouseName">
        <line-label slot="label" :class="elementDict.warehouseName.isRequire ? 'blue' : ''" :label="elementDict.warehouseName.label" />
        <el-select
          ref="warehouseName"
          v-model="form.warehouseName"
          no="warehouseName"
          :disabled="!warehouseEabled||!form.warehouseCmp"
          :allow-create="true"
          filterable
          :clearable="true"
          @change="warehouseNameChangeHandler"
        >
          <el-option
            v-for="(item,index) in warehouseNameList"
            :key="index"
            :label="item.warehouseName"
            :value="item.warehouseName"
          />
        </el-select>
      </el-form-item>
      <template v-if="elementDict.diffPlacesCollaborate.slaveVisible" slot="diffPlacesCollaborate">
        <el-checkbox
          v-model="form.diffPlacesCollaborate"
          no="diffPlacesCollaborate"
          class="blue"
        >{{ $t('RailwayExport.isDiffPlacesCollaborate') }}</el-checkbox>
        <el-form-item :label="$t('RailwayExport.loadingPlaceCompany')">
          <cargo-company-select
            :disabled="!lclslaveEnabled"
            no="loadingPlaceCompany"
            :method-params="{companyLob:'railwayExport',loadingPlaceCompany:true,active:true}"
            :check-credit="true"
            :job="form"
            :tooltip="true"
            tooltip-tag-name="englishName"
            :default-value="form.loadingPlaceCompany||''"
            @change="p=>{form.loadingPlaceCompany=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.signBillPlaceCompany')">
          <cargo-company-select
            :disabled="!lclslaveEnabled"
            no="signBillPlaceCompany"
            :method-params="{companyLob:'railwayExport',signBillPlaceCompany:true,active:true}"
            :check-credit="true"
            :job="form"
            :tooltip="true"
            tooltip-tag-name="englishName"
            :default-value="form.signBillPlaceCompany||''"
            @change="p=>{form.signBillPlaceCompany=p.value}"
          />
        </el-form-item>
      </template>
      <template v-if="elementDict.fullShipment.slaveVisible" slot="fullShipment">
        <el-checkbox
          v-model="form.fullShipment"
          :disabled="!lclslaveEnabled"
          no="fullShipment"
          class="blue"
        >{{ $t('RailwayExport.isFullShipment') }}</el-checkbox>
        <el-form-item :label="$t('RailwayExport.dischargePortCompany')">
          <cargo-company-select
            :disabled="!lclslaveEnabled"
            no="dischargePortCompany"
            :method-params="{companyLob:'railwayExport',dischargePortCompany:true,active:true}"
            :check-credit="true"
            :job="form"
            :tooltip="true"
            tooltip-tag-name="englishName"
            :default-value="form.dischargePortCompany||''"
            @change="p=>{form.dischargePortCompany=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('RailwayExport.destinationPortCompany')">
          <cargo-company-select
            :disabled="!lclslaveEnabled"
            no="destinationPortCompany"
            :method-params="{companyLob:'railwayExport',destinationPortCompany:true,active:true}"
            :check-credit="true"
            :job="form"
            :tooltip="true"
            tooltip-tag-name="englishName"
            :default-value="form.destinationPortCompany||''"
            @change="p=>{form.destinationPortCompany=p.value}"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.boxOneWay.slaveVisible" slot="boxOneWay">
        <line-label slot="label" :class="elementDict.boxOneWay.isRequire ? 'blue' : ''" :label="elementDict.boxOneWay.label" />
        <el-select v-model="form.boxOneWay" no="boxOneWay">
          <el-option :label="$t('CargoMsg.Cargo_PleaseSelectP')" :value="0" />
          <el-option :label="$t('CargoMsg.Cargo_OneWay')" :value="1" />
          <el-option :label="$t('CargoMsg.Cargo_Circulation')" :value="2" />
        </el-select>
      </el-form-item>
      <template v-if="elementDict.seaEq.slaveVisible" slot="seaEq">
        <el-form-item
          v-if="form.containerLoadType==='FCL'||form.containerLoadType==='BB'"
          label-width="0"
          class="auto-width"
        >
          <booking-sea-eq-data-grid
            ref="bookingSeaEqDataGrid"
            :value="seaEqList"
            :container-load-type="form.containerLoadType"
            :hide-soc="true"
            :is-edit="isEdit"
            :job="form"
          />
        </el-form-item>
        <el-form-item
          v-if="form.containerLoadType==='BULK'"
          label-width="0"
          class="auto-width"
        >
          <booking-bulk-data-grid
            :value="cargoBulkDetailList"
            :job-uuid="form.uuid"
            :is-edit="isEdit"
          />
        </el-form-item>
        <el-form-item
          v-if="form.containerLoadType==='SPA'"
          label-width="0"
          class="auto-width"
        >
          <booking-special-data-grid
            :value="seaEqList"
            :hide-eq-type="true"
            :hide-soc="true"
            :is-edit="isEdit"
            :job="form"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.quantityConsignActual.slaveVisible" slot="quantityConsignActual">
        <line-label slot="label" :class="elementDict.quantityConsignActual.isRequire ? 'blue' : ''" :label="elementDict.quantityConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.quantityContract"
            no="quantityContract"
            :precision="0"
            :min="0"
            @change="pm.jobContractQwcChange(1);calcEstVolumetricAndChargeWeight()"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            ref="quantityActual"
            v-model="form.quantityActual"
            :disabled="pm.billChargeFlag"
            no="quantityActual"
            :precision="0"
            :min="0"
            @change="SEUtils.changeQWCRule(null,()=>{form.quantityContract=form.quantityActual});pm.changeSynBillOfLadingQWC();pm.refContainerUsageQwc(2);quantityActualChange()"
          />
          <span style="width:65px;">PCS</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.weightConsignActual.slaveVisible" slot="weightConsignActual">
        <line-label slot="label" :class="elementDict.weightConsignActual.isRequire ? 'blue' : ''" :label="elementDict.weightConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.weightContract"
            no="weightContract"
            :precision="3"
            :min="0"
            @change="weightContractChange();calcEstVolumetricAndChargeWeight()"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            ref="weightActual"
            v-model="form.weightActual"
            no="weightActual"
            :precision="3"
            :min="0"
            :disabled="pm.billChargeFlag"
            @change="weightActualChange"
          />
          <span style="width:65px;">KGS</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cubageConsignActual.slaveVisible" slot="cubageConsignActual">
        <line-label slot="label" :class="elementDict.cubageConsignActual.isRequire ? 'blue' : ''" :label="elementDict.cubageConsignActual.label" />
        <div style="display: flex">
          <auto-number-input
            v-model="form.cubageContract"
            no="cubageContract"
            :precision="3"
            :min="0"
            @change="cubageContractChange();calcEstVolumetricAndChargeWeight()"
          />
          <span style="padding:0 2px;">/</span>
          <auto-number-input
            ref="cubageActual"
            v-model="form.cubageActual"
            no="cubageActual"
            :precision="3"
            :min="0"
            :disabled="!cubageActualEnabled"
            @change="cubageActualChange"
          />
          <span style="width:65px;">CBM</span>
        </div>
      </el-form-item>
      <el-form-item
        v-show="form.containerLoadType==='BULK' && elementDict.insideQuantitySize.slaveVisible"
        slot="insideQuantitySize"
      >
        <line-label slot="label" :class="elementDict.insideQuantitySize.isRequire ? 'blue' : ''" :label="elementDict.insideQuantitySize.label" />
        <el-input-number
          v-model="form.insideQuantitySize"
          no="insideQuantitySize"
          :precision="0"
          :controls="false"
          style="width:100%;"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.packing.slaveVisible" slot="packing">
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          no="packing"
          :default-value="form.packing"
          @change="p=>{form.packing=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoChineseName.slaveVisible" slot="cargoChineseName">
        <div slot="label">
          <line-label :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
          <br>
          <el-button
            v-show="isEdit"
            no="SelectCargoChineseName"
            type="primary"
            @click="showHsCodeSearchDialog($t('Message.SelectCargoChineseName'),p=>{form.cargoChineseName=p.commodityName})"
          >{{ $t('SeaExport.Search') }}</el-button>
        </div>
        <div style="position:relative">
          <el-input
            v-model="form.cargoChineseName"
            no="cargoChineseName"
            type="textarea"
            :rows="6"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),form.cargoChineseName,false,val=>{form.cargoChineseName=val})"
          />
          <char-count :value="form.cargoChineseName" />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cargoEnglishName.slaveVisible" slot="cargoEnglishName">
        <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
        <cargo-rich-textarea
          v-model="form.cargoEnglishName"
          :show-count="true"
          no="cargoEnglishName"
          :disabled="readonly"
          :text-chars="0"
          :auto-uppercase="isUppercaseByConfig"
          style="height: 110px"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,isUppercaseByConfig,val=>{form.cargoEnglishName=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.mark.slaveVisible" slot="mark">
        <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
        <cargo-rich-textarea
          v-model="form.mark"
          :show-count="true"
          :disabled="readonly"
          no="mark"
          :text-chars="0"
          :auto-uppercase="isUppercaseByConfig"
          style="height: 110px"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,isUppercaseByConfig,val=>{form.mark=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.txtSalesOffice.slaveVisible" slot="txtSalesOffice">
        <line-label slot="label" :class="elementDict.txtSalesOffice.isRequire ? 'blue' : ''" :label="elementDict.txtSalesOffice.label" />
        <el-input :value="txtSalesOffice" :disabled="true" no="txtSalesOffice" />
      </el-form-item>
      <el-form-item v-if="elementDict.sales.slaveVisible" slot="sales">
        <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
        <div style="display: flex;justify-content: space-between">
          <cargo-user-select
            ref="sales"
            :disabled="!saleEnabled"
            no="salesRecord"
            :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
            :default-value="form.sales||''"
            :static-options="salesList"
            :placeholder="salesPrompt"
            :merge-load="true"
            style="flex: 1"
            @change="p=>{form.salesRecord = p.value;pm.salesChangeHandler(p);}"
          />&nbsp;
          <el-checkbox
            v-model="form.provisioned"
            no="provisioned"
            style="margin-left: 5px"
            :disabled="true"
          >{{ $t('SeaExport.Accrued') }}</el-checkbox>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSalesId.slaveVisible" slot="cargoSalesId">
        <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
        <cargo-user-select
          no="cargoSalesId"
          :method-params="{category:'role',shape:'salesOfGoods'}"
          :default-value="form.cargoSalesId||''"
          :merge-load="true"
          :static-options="cargoSalesList"
          @change="p=>{form.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.salesDepartment.slaveVisible" slot="salesDepartment">
        <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
        <cargo-department-new-select
          :disabled="!form.sales"
          no="salesDepartment"
          :enables="true"
          :sales-id="Number(form.sales)"
          :office-id="form.salesOffice"
          :department-id="Number(form.salesDepartment)"
          @change="p=>{form.salesDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opOffice.slaveVisible" slot="opOffice">
        <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
        <cargo-office-select
          :disabled="(!isRegionalCommission && pm.isEntrustOrder(true)) || opOfficeDisabled"
          :is-regional-commission="isRegionalCommission"
          no="opOffice"
          :office-id="Number(form.opOffice)"
          @change="p=>{form.opOffice=p.value;form.opDepartment=0;opOfficeChargeHandler();contractRuleFieldChange(form.customerId, form.designationAgent)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opDepartment.slaveVisible" slot="opDepartment">
        <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
        <cargo-department-select
          :disabled="pm.isWithinCloseAccountDate"
          no="opDepartment"
          :enables="true"
          :office-id="Number(form.opOffice)"
          :department-id="Number(form.opDepartment)"
          @change="p=>{form.opDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.op.slaveVisible" slot="op">
        <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
        <cargo-user-select
          :disabled="!opEabled"
          no="op"
          :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
          :default-value="form.op||''"
          :merge-load="true"
          :static-options="userPortRoleData.op"
          @change="p=>{form.op=p.value;pm.txtOPChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrOffice.slaveVisible" slot="csrOffice">
        <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
        <cargo-office-select
          no="csrOffice"
          :disabled="true"
          :office-id="Number(form.csrOffice)"
          @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrDepartment.slaveVisible" slot="csrDepartment">
        <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
        <cargo-department-select
          no="csrDepartment"
          :office-id="Number(form.csrOffice)"
          :enables="true"
          :department-id="Number(form.csrDepartment)"
          @change="p=>{form.csrDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csr.slaveVisible" slot="csr">
        <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
        <cargo-user-select
          ref="csr"
          no="csr"
          :method-params="{officeId:pm.isEntrustOrder||form.salesOffice===1?form.opOffice:form.salesOffice,category:'role',shape:'csr'}"
          :default-value="form.csr||''"
          :merge-load="true"
          :static-options="userPortRoleData.csr"
          @change="p=>{pm.csrChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.siteOP.slaveVisible" slot="siteOP">
        <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
        <cargo-user-select
          :method-params="{officeId:form.opOffice,category:'role',shape:'siteOp'}"
          :default-value="form.siteOP||''"
          :static-options="userPortRoleData.siteOp"
          @change="p=>{JobUtils.siteOpChangeHandler(form, p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.overseaOp.slaveVisible" slot="overseaOp">
        <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
        <cargo-user-select
          ref="overseaOp"
          no="overseaOp"
          :method-params="{category:'role',shape:'overseaOp'}"
          :default-value="form.overseaOp||''"
          :static-options="isHC ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
          :merge-load="true"
          @change="p=>{form.overseaOp=p.value;pm.overseaOpChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcOffice.slaveVisible" slot="dcOffice">
        <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
        <cargo-office-select
          no="dcOffice"
          :disabled="true"
          :office-id="Number(form.dcOffice)"
          @change="p=>{form.dcOffice=p.value;form.dcDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcDepartment.slaveVisible" slot="dcDepartment">
        <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
        <cargo-department-select
          no="dcDepartment"
          :office-id="Number(form.dcOffice)"
          :enables="true"
          :department-id="Number(form.dcDepartment)"
          @change="p=>{form.dcDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dc.slaveVisible" slot="dc">
        <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
        <cargo-user-select
          ref="dc"
          no="dc"
          :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
          :default-value="form.dc||''"
          :merge-load="true"
          :static-options="userPortRoleData.doc"
          @change="p=>{pm.dcChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.slaveVisible" slot="plannerOffice">
        <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
        <cargo-office-select
          no="plannerOffice"
          :disabled="true"
          :office-id="Number(form.plannerOffice)"
          @change="p=>{form.plannerOffice=p.value;form.plannerDepartment=0}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.slaveVisible" slot="plannerDepartment">
        <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
        <cargo-department-select
          no="plannerDepartment"
          :office-id="Number(form.plannerOffice)"
          :enables="true"
          :department-id="Number(form.plannerDepartment)"
          @change="p=>{form.plannerDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.planner.slaveVisible" slot="planner">
        <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
        <cargo-user-select
          no="planner"
          :method-params="{officeId:form.opOffice,category:'role',shape:'railwayLine'}"
          :default-value="form.planner||''"
          :merge-load="true"
          :static-options="userPortRoleData.railwayLine"
          @change="p=>{form.planner=p.value;pm.txtPlannerChangeHandler(p)}"
        />
      </el-form-item>
      <el-form-item v-show="isAddUserDefinedRoles && elementDict.userDefinedRoleId1.slaveVisible" slot="userDefinedRoleId1">
        <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
        <cargo-user-select
          ref="userDefinedRoleId1"
          no="userDefinedRoleId1"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
          :default-value="form.userDefinedRoleId1||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole1"
          @change="p=>{pm.userDefinedRoleId1Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-show="isAddUserDefinedRoles && elementDict.userDefinedRoleId2.slaveVisible" slot="userDefinedRoleId2">
        <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
        <cargo-user-select
          ref="userDefinedRoleId2"
          no="userDefinedRoleId2"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
          :default-value="form.userDefinedRoleId2||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole2"
          @change="p=>{pm.userDefinedRoleId2Handler(p)}"
        />
      </el-form-item>
      <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.slaveVisible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
        <micro-app
          name="child-user-defined-role-re-userDefinedRoleId3"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChangeUI"
        />
      </div>
      <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.slaveVisible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
        <micro-app
          name="child-user-defined-role-re-userDefinedRoleId4"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChangeUI"
        />
      </div> -->
      <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId3">
        <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
        <cargo-user-select
          ref="userDefinedRoleId3"
          no="userDefinedRoleId3"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
          :default-value="form.userDefinedRoleId3||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole3"
          @change="p=>{pm.userDefinedRoleId3Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId4">
        <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
        <cargo-user-select
          ref="userDefinedRoleId4"
          no="userDefinedRoleId4"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
          :default-value="form.userDefinedRoleId4||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole4"
          @change="p=>{pm.userDefinedRoleId4Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId5">
        <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
        <cargo-user-select
          ref="userDefinedRoleId5"
          no="userDefinedRoleId5"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
          :default-value="form.userDefinedRoleId5||''"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId5Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId6 && elementDict.userDefinedRoleId6.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId6">
        <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
        <cargo-user-select
          ref="userDefinedRoleId6"
          no="userDefinedRoleId6"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
          :default-value="form.userDefinedRoleId6||''"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId6Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId7 && elementDict.userDefinedRoleId7.slaveVisible && isAddUserDefinedRoles" slot="userDefinedRoleId7">
        <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
        <cargo-user-select
          ref="userDefinedRoleId7"
          no="userDefinedRoleId7"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
          :default-value="form.userDefinedRoleId7||''"
          :merge-load="true"
          @change="p=>{pm.userDefinedRoleId7Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
        <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
        <cargo-user-select
          ref="userDefinedRoleId8"
          no="userDefinedRoleId8"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
          :default-multiple-value="toNumArray(form.userDefinedRoleId8)"
          :multiple="true"
          :merge-load="true"
          :placeholder="readonly ? ' ' : ''"
          @change="p=>{form.userDefinedRoleId8=toTxt(p.value)}"
        />
      </el-form-item>
      <el-form-item
        v-if="elementDict.satisfiedRequests.slaveVisible"
        slot="satisfiedRequests"
        label-width="0"
        class="auto-width"
      >
        <special-requests-grid
          ref="selectedSpecialRequest"
          v-model="form.satisfiedRequests"
          :is-edit="isEdit"
          :customer-id="form.customerId"
          :lob="form.lob"
          :job="form"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.operationContent.slaveVisible" slot="operationContent">
        <line-label slot="label" :class="elementDict.operationContent.isRequire ? 'blue' : ''" :label="elementDict.operationContent.label" />
        <el-tooltip :content="form.operationContent" placement="left">
          <div
            slot="content"
            v-html="form.operationContent ? form.operationContent.replace(/[\n]/g,'</br>') : $t('SeaExport.NoData')"
          />
          <el-input
            :value="form.operationContent"
            no="operationContent"
            :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddOperationRequirements')"
            type="textarea"
            :rows="4"
            @dblclick.native="selectOperationReqDialog.value=form.operationContent;selectOperationReqDialog.visible=isEdit"
          />
        </el-tooltip>
      </el-form-item>
      <el-form-item v-if="elementDict.operationTips.slaveVisible" slot="operationTips">
        <line-label slot="label" :class="elementDict.operationTips.isRequire ? 'blue' : ''" :label="elementDict.operationTips.label" />
        <el-input
          v-model="form.operationTips"
          no="operationTips"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.operationTips.label,form.operationTips,false,val=>{form.operationTips=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.surchargeTerms.slaveVisible" slot="surchargeTerms">
        <line-label slot="label" :class="elementDict.surchargeTerms.isRequire ? 'blue' : ''" :label="elementDict.surchargeTerms.label" />
        <el-input
          :value="txtSurchargeTerms"
          no="txtSurchargeTerms"
          :placeholder="readonly ? '' : $t('SeaExport.DoubleClickToAddExtraChargeClause')"
          type="textarea"
          :rows="4"
          @dblclick.native="selectSurchargeTermsDialog.rowData=form.surchargeTerms;selectSurchargeTermsDialog.visible=true"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.txtWhs.slaveVisible" slot="txtWhs">
        <line-label slot="label" :class="elementDict.txtWhs.isRequire ? 'blue' : ''" :label="elementDict.txtWhs.label" />
        <el-input :disabled="true" no="txtWhs" type="textarea" :rows="4" :value="txtWhs" />
      </el-form-item>
      <el-form-item v-if="elementDict.remarks.slaveVisible" slot="remarks">
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <el-input
          v-model="form.remarks"
          no="remarks"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.remarks.label,form.remarks,false,val=>{form.remarks=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField1.slaveVisible" slot="userDefinedField1">
        <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
        <el-input
          v-model="form.userDefinedField1"
          no="userDefinedField1"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,form.userDefinedField1,val=>{form.userDefinedField1=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField2.slaveVisible" slot="userDefinedField2">
        <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
        <el-input
          v-model="form.userDefinedField2"
          no="userDefinedField2"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,form.userDefinedField2,val=>{form.userDefinedField2=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField3.slaveVisible" slot="userDefinedField3">
        <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
        <el-input
          v-model="form.userDefinedField3"
          no="userDefinedField3"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,form.userDefinedField3,val=>{form.userDefinedField3=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField4.slaveVisible" slot="userDefinedField4">
        <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
        <el-input
          v-model="form.userDefinedField4"
          no="userDefinedField4"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.label,form.userDefinedField4,val=>{form.userDefinedField4=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.exportControlledProduct && elementDict.exportControlledProduct.slaveVisible" slot="exportControlledProduct">
        <line-label slot="label" :class="elementDict.exportControlledProduct.isRequire ? 'blue' : ''" :label="elementDict.exportControlledProduct.label" />
        <el-select
          v-model="form.exportControlledProduct"
          no="exportControlledProduct"
          :disabled="readonly"
          :placeholder="''"
          :clearable="true"
          size="mini"
        >
          <el-option
            v-for="(item,index) in EXPORT_CONTROLLED_PRODUCT"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.slaveVisible" slot="taxNature">
        <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
        <el-select
          v-model="form.taxNature"
          no="taxNature"
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in TAX_NATURES"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form
        v-show="elementDict.shipper.slaveVisible"
        slot="shipper"
        label-width="50px"
        label-position="left"
        style="margin-right:10px"
      >
        <el-form-item>
          <template slot="label">
            <line-label :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
            <char-count :form="form" prefix="shipper" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <cargo-company-select
            no="shipperId"
            :disabled="readonly"
            :method-params="{shipper:true,active:true}"
            :default-value="form.shipperId||''"
            placeholder=" "
            style="display: inline-block;width:196px;"
            @change="data => {pm.shipperChange(data)}"
          />
          <el-button
            no="shipperBillAddress"
            :disabled="readonly"
            type="primary"
            style="margin-left: 5px;"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}</el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'shipperLine'+i"
            v-model="form['shipperLine'+i]"
            :disabled="readonly"
            :no="'shipperLine'+i"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @change="()=>wrapAddr(form,'shipperLine'+i,i+1 > 6 ? null :'shipperLine'+(i+1),'')"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),notUppercaseShipperConsigneNotify,splitShipperLine)"
          />
        </el-form-item>
      </el-form>
      <el-form
        v-show="elementDict.consignee.slaveVisible"
        slot="consignee"
        label-width="65px"
        label-position="left"
        style="margin-right:20px"
      >
        <el-form-item>
          <template slot="label">
            <line-label :class="elementDict.consignee.isRequire ? 'blue' : ''" :label="elementDict.consignee.label" />
            <char-count :form="form" prefix="consignee" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <cargo-company-select
            no="consigneeId"
            :disabled="readonly"
            :method-params="{consignee:true,active:true}"
            :default-value="form.consigneeId||''"
            placeholder=" "
            style="display: inline-block;width:196px;"
            @change="data => {pm.consigneeChange(data)}"
          />
          <el-button
            no="consigneeBillAddress"
            :disabled="readonly"
            type="primary"
            style="margin-left: 5px;"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}</el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'consigneeLine'+i"
            v-model="form['consigneeLine'+i]"
            :disabled="readonly"
            :no="'consigneeLine'+i"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @change="()=>wrapAddr(form,'consigneeLine'+i,i+1 > 6 ? null :'consigneeLine'+(i+1),'')"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),notUppercaseShipperConsigneNotify,splitConsigneeLine)"
          />
        </el-form-item>
      </el-form>
      <el-form
        v-show="elementDict.notify.slaveVisible"
        slot="notify"
        label-width="50px"
        label-position="left"
        style="margin-right:20px"
      >
        <el-form-item>
          <template slot="label">
            <line-label :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
            <char-count :form="form" prefix="notify" style="position:static;display:block;font-size:10px;color:#909399" />
          </template>
          <cargo-company-select
            no="notifyId"
            :disabled="readonly"
            :method-params="{notify:true,active:true}"
            :default-value="form.notifyId||''"
            placeholder=" "
            style="display: inline-block;width:196px;"
            @change="data => {pm.notifyChange(data)}"
          />
          <el-button
            no="noconifyBillAddress"
            :disabled="readonly"
            type="primary"
            style="margin-left: 5px;"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}</el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'notifyLine'+i"
            v-model="form['notifyLine'+i]"
            :disabled="readonly"
            :no="'notifyLine'+i"
            :auto-uppercase="notUppercaseShipperConsigneNotify"
            @change="()=>wrapAddr(form,'notifyLine'+i,i+1 > 6 ? null :'notifyLine'+(i+1),'')"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),notUppercaseShipperConsigneNotify,splitNotifyLine)"
          />
        </el-form-item>
      </el-form>
      <div v-if="elementDict.alsoNotify.slaveVisible" slot="alsoNotify">
        <line-label :class="elementDict.alsoNotify.isRequire ? 'blue' : ''" style="display:inline-block;line-height:28px;padding-bottom: 5px;" :label="elementDict.alsoNotify.label" />
        <br>
        <cargo-textarea
          v-model="form.alsoNotify"
          no="alsoNotify"
          type="textarea"
          :rows="12"
          :disabled="readonly"
          class="also-notify"
          @dblclick.native="showAdvanceTextDialog(elementDict.alsoNotify.label,form.alsoNotify,notUppercaseShipperConsigneNotify,val=>{form.alsoNotify=val})"
        />
      </div>
      <el-form-item v-if="elementDict.rateType && elementDict.rateType.slaveVisible" slot="rateType">
        <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
        <el-select
          v-model="form.rateType"
          :disabled="readonly"
          no="rateType"
          clearable
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in rateType"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
    </tab-booking-FCLUICustom-layout>
    <!-- 联系人弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="contact"
      :visible.sync="contactDialog.visible"
      :title="$t('SeaExport.ContactPerson')"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-position="right" label-width="100px">
        <el-form-item :label="$t('SeaExport.ContactPerson')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.contactPerson"
            no="contactPerson"
            style="width: 170px;"
          />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Role')+'：'">
          <el-input :disabled="true" :value="contactDialog.data.role" no="role" style="width: 170px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Tel')+'：'">
          <el-input :disabled="true" :value="contactDialog.data.telephone" no="telephone" style="width: 170px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Mobile')+'：'">
          <el-input :disabled="true" :value="contactDialog.data.mobile" no="mobile" style="width: 170px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Fax')+'：'">
          <el-input :disabled="true" :value="contactDialog.data.fax" no="fax" style="width: 170px;" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Email')+'：'">
          <el-input :disabled="true" :value="contactDialog.data.email" no="email" style="width: 170px;" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks')+'：'">
          <el-input
            :disabled="true"
            :value="contactDialog.data.remarks"
            no="remarks"
            type="textarea"
            :rows="3"
            style="width: 170px;"
          />
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceText"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :warning-count="-1"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="confirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- HS编号和中文品名检索弹窗 -->
    <hs-code-search-dialog
      :visible.sync="hsCodeSearchDialog.visible"
      :title="hsCodeSearchDialog.title"
      :hide-country-code="true"
      @callback="hsCodeSearchDialog.successCallback"
    />
    <!-- 操作要求弹窗 -->
    <select-operation-req-dialog
      :visible.sync="selectOperationReqDialog.visible"
      lob="RE"
      :value="selectOperationReqDialog.value"
      @callback="val=>{form.operationContent=val}"
    />
    <!-- 附加费条款弹窗 -->
    <select-surcharge-terms-dialog
      :visible.sync="selectSurchargeTermsDialog.visible"
      :job-uuid="form.uuid"
      :row-data="selectSurchargeTermsDialog.rowData"
      :disabled="readonly"
      @callback="handleSurchargeTerms"
    />
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="form"
      @callback="codeSearchCallback"
    />
    <!-- Fba收发通地址弹窗 -->
    <fba-bill-address-dialog
      :visible.sync="fbaBillAddressDialog.visible"
      :job="fbaJob"
      @callback="fbaCodeSearchCallback"
    />
    <!-- 订舱章弹窗 -->
    <stamp-picture-view
      :visible.sync="stampPictureView.visible"
      :business-documents="stampPictureView.businessDocuments"
    />
  </div>
</template>

<script>
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import tabBookingFCLUICustomLayout from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingFCLUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabBookingFCL from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingFCL.vue'
import StrUtils from '@/utils/StrUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import microApp from '@micro-zoe/micro-app'
import { toNumArray, toTxt } from '@/utils/commonUtil'

export default {
  name: 'ReTabBookingFCLUICustom',
  components: { cargoTextarea, tabBookingFCLUICustomLayout },
  extends: tabBookingFCL,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      userDefinedRoleDataUI: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.form ? this.form.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      }
    }
  },
  computed: {
    lob() {
      return this.form.lob
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    },
    lob() {
      this.loadPageConfig()
    },
    'form.exportControlledProduct': {
      immediate: true,
      handler(val) {
        if (val === 0) {
          this.form.exportControlledProduct = ''
        }
      }
    }
  },
  async created() {
    this.loadPageConfig()
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify()
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageType = this.lob === 'RE' ? UICustomConstants.RAILWAY_BOOKING_RE_BASIC : UICustomConstants.RAILWAY_BOOKING_RI_BASIC
        const pageConfig = UICustomUtil.getPageConfig(pageType, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    async validateForm() {
      const form = this.form
      for (const key in this.fieldDict) {
        const field = this.fieldDict[key]
        if (field.slaveVisible && field.isRequire) {
          if (key === 'agentRefNo') {
            if (form.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
              continue
            }
          }
          if (key === 'secondaryCustomJobType') {
            if (!(this.form.customJobType && this.secondaryCustomJobTypeList.length > 0)) {
              continue
            }
          }
          if (key === 'projectName' || key === 'projectBatch') {
            if (!this.openProjectConfig) {
              continue
            }
          }
          if (key === 'userDefinedRoleId1' || key === 'userDefinedRoleId2') {
            if (!this.isAddUserDefinedRoles) {
              continue
            }
          }
          if (key === 'shipperLine1') {
            let shipperLine = ''
            for (let i = 1; i <= 7; ++i) {
              shipperLine += form['shipperLine' + i]
            }
            if (StrUtils.isEmpty(shipperLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
            continue
          }
          if (key === 'consigneeLine1') {
            let consigneeLine = ''
            for (let i = 1; i <= 7; ++i) {
              consigneeLine += form['consigneeLine' + i]
            }
            if (StrUtils.isEmpty(consigneeLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
            continue
          }
          if (key === 'notifyLine1') {
            let notifyLine = ''
            for (let i = 1; i <= 7; ++i) {
              notifyLine += form['notifyLine' + i]
            }
            if (StrUtils.isEmpty(notifyLine)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
            continue
          }
          if (key.startsWith('shipperLine') || key.startsWith('consigneeLine') || key.startsWith('notifyLine')) {
            continue
          }
          if (key === 'transfer') {
            if (form.transfer && StrUtils.isEmpty(form.transferStation)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else if (key === 'designationAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else if (key === 'customClaim') {
            const obj = getObjectByCache(this.selectTypeNames.basic_data_CustomsMode, 'serialNum', form.customClaim)
            if (!obj) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else if (key === 'taxNature') {
            if (form[key] === '' || form[key] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
            }
          } else {
            if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
              const label = this.elementDict[key] ? this.elementDict[key].label : field.label
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabBookingFCL')
            }
          }
        }
      }
      if (this.elementDict.seaEq && this.elementDict.seaEq.slaveVisible && this.elementDict.seaEq.isRequire) {
        if (form.containerLoadType === 'FCL' || form.containerLoadType === 'BB') {
          if (!this.seaEqList || this.seaEqList.length === 0) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.seaEq.label]), 'tabBookingFCL')
          }
          for (const seaEq of this.seaEqList) {
            if (!seaEq.eqQuantity) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.ContainerAmount')]), 'tabBookingFCL')
            }
          }
        }
      }
      if (this.elementDict.warehouseCmp && this.elementDict.warehouseCmp.slaveVisible && this.elementDict.warehouseCmp.isRequire) {
        if (!this.form.warehouseCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseCmp.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.warehouseName && this.elementDict.warehouseName.slaveVisible && this.elementDict.warehouseName.isRequire && this.openWarehouse && this.warehouseEabled && this.form.warehouseCmp) {
        if (StrUtils.isEmpty(this.form.warehouseName)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.warehouseName.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.carryingCmp && this.elementDict.carryingCmp.slaveVisible && this.elementDict.carryingCmp.isRequire && this.form.landTransportation) {
        if (!this.form.carryingCmp) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.carryingCmp.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.quantityConsignActual && this.elementDict.quantityConsignActual.slaveVisible && this.elementDict.quantityConsignActual.isRequire) {
        if (!this.form.quantityContract || !this.form.quantityActual) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.quantityConsignActual.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.weightConsignActual && this.elementDict.weightConsignActual.slaveVisible && this.elementDict.weightConsignActual.isRequire) {
        if (!this.form.weightContract || !this.form.weightActual) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.weightConsignActual.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.cubageConsignActual && this.elementDict.cubageConsignActual.slaveVisible && this.elementDict.cubageConsignActual.isRequire) {
        if (!this.form.cubageContract || !this.form.cubageActual) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.cubageConsignActual.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.txtSalesOffice && this.elementDict.txtSalesOffice.slaveVisible && this.elementDict.txtSalesOffice.isRequire) {
        if (StrUtils.isEmpty(this.txtSalesOffice)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.txtSalesOffice.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.surchargeTerms && this.elementDict.surchargeTerms.slaveVisible && this.elementDict.surchargeTerms.isRequire) {
        if (StrUtils.isEmpty(this.txtSurchargeTerms)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.surchargeTerms.label]), 'tabBookingFCL')
        }
      }
      if (this.elementDict.txtWhs && this.elementDict.txtWhs.slaveVisible && this.elementDict.txtWhs.isRequire) {
        if (StrUtils.isEmpty(this.txtWhs)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.txtWhs.label]), 'tabBookingFCL')
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    setUserDefinedRoleDataUI() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData3.fieldData = this.form.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-re-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData4.fieldData = this.form.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-re-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChangeUI(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleDataUI()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.form.userDefinedRoleId3 = e.detail.data.fieldData
            this.pm.userDefinedRoleId3Handler(this.form.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.form.userDefinedRoleId4 = e.detail.data.fieldData
            this.pm.userDefinedRoleId4Handler(this.form.userDefinedRoleId4)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .poNoClass {
    /deep/ .el-input.is-disabled .el-input__inner {
      color: red !important;
    }
  }
  /deep/ .also-notify {
    width: 310px;
    .el-textarea__inner {
      height: 230px;
    }
  }
</style>
